<div class="paypointReportsComponent p-3 sm:p-4 md:p-6 w-full maximum-width h-[calc(100vh-80px)] overflow-hidden flex flex-col">
  <div class="reportsTabContent flex-1 min-h-0">
    <metabase-embed
      [dashboardId]="payPointConfig.dashboardId"
      [instanceUrl]="payPointConfig.instanceUrl"
      [secretKey]="payPointConfig.secretKey"
      [orgIdOverride]="orgId"
    />
  </div>
</div>
